var _defs, _path, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLikePurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_like_purple",
    "data-name": "ico like purple",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.406,
    height: 24.406,
    viewBox: "0 0 24.406 24.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .clsss-1 {\r\n        fill: #c064db;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_copy",
    "data-name": "Ellipse 2 copy",
    className: "clsss-1",
    d: "M596.8,170.205a12.217,12.217,0,1,1-12.2,12.216A12.207,12.207,0,0,1,596.8,170.205Z",
    transform: "translate(-584.594 -170.219)"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico_like_copy",
    "data-name": "ico like copy",
    x: 4.406,
    y: 3.781,
    width: 16,
    height: 16,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABUElEQVQ4jZXTMUtXYRQG8J9mmDgFajU0iBBNtYdLQ0NBY9BWH8BoqQ/RHNXS3tDW1OAXaBCkKJKIQDIQAilIU4Mnjr5/kNv1/6cDL7zn3nOfc57nOVeSYWc+yackX5Ms9tWNGx438QOP8AIT3epRAItYwWP8wcl/KoaMP5VkJ8mZJDeSfPxfCs+whk08xKu+orFC6Ylz+IZLeIcNPMd6e7eDl5UfB1APn2Cp5U9xBVv4jVO4gPsFcLoumG6KX8cernZAS8D9DsVrZctyQy2us63TWM9U+538C3ZLyc2Osm+TnB+xYHVmkqyXC98x11DP4gQmh7gziNv4Od7GHdg5yHuV7UQ1y6hNPC7quxL5TXH5cITXRJLVJJMj+M/mMKbLhQXcwmfM4zLuHaAf6rPd/oPd1vlis/A1ftUePMCdVlT8C2im7UUJetTSwf097mLvL8/sCIS+IYW4AAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLikePurple);
export default __webpack_public_path__ + "static/media/ico_like_purple.b896ff01.svg";
export { ForwardRef as ReactComponent };